import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../../components/ErpTemplate';
import { FaArrowLeft, FaPlus, FaSave, FaTrash, FaFileInvoiceDollar, FaMoneyCheckAlt } from 'react-icons/fa';
import api from '../../../../services/api';
import { useHistory, useLocation } from 'react-router-dom';
import ReactSelect from '../../../../components/ReactSelect';
import { data, dataMysql, extract, pontoVirgula, virgulaPonto } from '../../../../util/util';
import Data from '../../../../components/Data';
import { FinField, FinInput, FinValor, FinTextarea } from '../../../../components/FinField';
import { toast } from 'react-toastify';
import moment from 'moment';
import { useSetFullBreadcrumbTrail } from '../../../../context/BreadcrumbContext';
import '../../../../css/financeiro-parcela-pagar.css';

// Redesign 2026-08-05 (.fin-pp): a tela era o template antigo (form-floating,
// card bootstrap, tabela crua). SÓ o visual mudou — buscar/validar/salvar,
// endpoints e a mecânica de estado são os originais.
export default function CadastroParcelaReceber({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem("empresa");
    const token = localStorage.getItem('token');
    const [dados, setDados] = useState({ tituloparcela: [] });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const history = useHistory();
    let { state } = useLocation();
    const vendas = state ? (state.vendas ? state.vendas : []) : [];
    const acao = state ? (state.acao ? state.acao : 'insert') : 'insert';
    const parcelaabater = state?.parcelaabater ?? null;
    const setFullTrail = useSetFullBreadcrumbTrail();

    const calculaTotalParcelaReceber = () => {
        dados.valorTotal = 0;
        dados.tituloparcela.forEach(function (item) {
            let valor = item.valor;
            if (typeof valor === 'string') {
                valor = virgulaPonto(valor);
            }
            let desconto = item.desconto || 0;
            if (typeof desconto === 'string') {
                desconto = virgulaPonto(desconto);
            }
            let juros = item.juros || 0;
            if (typeof juros === 'string') {
                juros = virgulaPonto(juros);
            }
            dados.valorTotal += ((valor || 0) + (juros || 0) - (desconto || 0));
        });
    }//calculaTotalParcelaReceber

    const buscar = () => {
        if (id) {//id do titulo recebido por url
            api({
                method: "get",
                action: '/financeiroTitulo/' + id,
                token: token,
            }).then(response => {
                //extrai dados internos para o array principal
                var dadosRecebidos = extract({
                    jsonLaravel: response.data.data,
                    chaves: ['conta', 'participante', 'evento']
                });
                //transforma data para javascript
                dadosRecebidos.competencia = data(dadosRecebidos.competencia);

                dadosRecebidos.tituloparcela.forEach((item, index) => {
                    dadosRecebidos.tituloparcela[index].vencimento = data(dadosRecebidos.tituloparcela[index].vencimento);
                });

                setDados(dadosRecebidos);
            }).catch(err => {
                //console.log(err)
            });
        } else { //nao tem id, pode ser inserir ou agrupar pagamentos
            var dadosIniciais = { competencia: new Date(), tituloparcela: [] };
            //se tiver vendas acha o cliente da primeira venda
            if (vendas.length > 0) {
                api({
                    token: token,
                    method: "get",
                    action: '/financeiroParcela/parcelasVendas',
                    params: { vendas: vendas }
                }).then(response => {
                    var dadosRecebidos = response.data.data;
                    dadosIniciais.acao = acao;
                    dadosIniciais.vendas = vendas;
                    dadosIniciais.participante = dadosRecebidos.vendas[0].cliente.id;
                    dadosIniciais.nomeParticipante = dadosRecebidos.vendas[0].cliente.nome;
                    var valorTotalVendas = dadosRecebidos.vendas.reduce((total, venda) => {
                        return total + parseFloat(venda.valorTotal);
                    }, 0);

                    //recupera parcelas
                    dadosIniciais.tituloparcela = [];
                    if (dadosRecebidos.parcelas.length > 0 && acao === "agrupar") {//ja tem parcelas cadastradas
                        dadosIniciais.tituloparcela = dadosRecebidos.parcelas.map((parcela) => {
                            return {
                                tipo: 2,
                                vencimento: data(parcela.vencimento),
                                valor: parcela.valor,
                                desconto: parcela.desconto || 0,
                                juros: parcela.juros || 0,
                                total: parcela.valor,
                                especie: {
                                    id: parcela.especie.id,
                                    nome: parcela.especie.nome
                                },
                                caixa: {
                                    id: parcela.caixa.id,
                                    nome: parcela.caixa.nome
                                }
                            };
                        });
                    } else {//nao tem parcelas cadastradas
                        //mostra uma parcela em branco com o valor total das vendas
                        dadosIniciais.tituloparcela.push({
                            tipo: 2,
                            vencimento: moment().format("DD/MM/YYYY"),
                            valor: valorTotalVendas,
                            desconto: 0,
                            juros: 0,
                            total: 0,
                            especie: {
                                id: null,
                                nome: null
                            },
                            caixa: {
                                id: null,
                                nome: null
                            }
                        });
                    }
                    setDados(dadosIniciais);
                }).catch(err => {
                    //console.log(err)
                });
            } else {
                setDados(dadosIniciais);//seta dados padões
            }
        }
    }; //buscar

    const validar = () => {
        // Valida Plano de Contas
        if (!dados.conta) {
            toast.error('É necessário preencher o Plano de Contas');
            return false;
        }

        // Valida se há pelo menos uma parcela cadastrada
        if (!dados.tituloparcela || dados.tituloparcela.length === 0) {
            toast.error('É necessário adicionar no mínimo 1 parcela para salvar');
            return false;
        }

        // Valida cada parcela
        for (let i = 0; i < dados.tituloparcela.length; i++) {
            const titulo = dados.tituloparcela[i];

            // Valida Espécie
            if (!titulo.especie || !titulo.especie.id) {
                toast.error(`É necessário preencher a Espécie na parcela ${i + 1}`);
                return false;
            }

            // Valida Caixa
            if (!titulo.caixa || !titulo.caixa.id) {
                toast.error(`É necessário preencher o Caixa na parcela ${i + 1}`);
                return false;
            }

            // Valida Valor
            const valor = typeof titulo.valor === 'string' ? virgulaPonto(titulo.valor) : (titulo.valor || 0);
            if (!valor || valor <= 0) {
                toast.error(`É necessário preencher um Valor maior que zero na parcela ${i + 1}`);
                return false;
            }

            // Valida Vencimento
            if (!titulo.vencimento) {
                toast.error(`É necessário preencher o Vencimento na parcela ${i + 1}`);
                return false;
            }
        }

        return true;
    };

    const salvar = () => {
        if (!validar()) {
            return false; //para codigo aqui
        }
        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);

        if (dados.competencia) {
            dados.competencia = dataMysql(dados.competencia);
        }
        //converte todas as datas para mysql
        if (dados.tituloparcela)
            dados.tituloparcela.forEach((registro, index) => {
                dados.tituloparcela[index].vencimento = dataMysql(dados.tituloparcela[index].vencimento);
            });

        if (id) {//update título unico
            api({
                method: 'put',
                action: '/financeiroTitulo/' + id,
                token: token,
                data: dados
            })
                .then(function (response) {
                    toast.success("Dados salvos com sucesso!");
                    history.push({
                        pathname: "/financeiroParcelaReceber",
                        state: { idTitulo: id }
                    });
                })
                .catch(function (error) {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        } else {//insert ou agrupar
            api({
                method: 'post',
                action: '/financeiroTitulo',
                token: token,
                data: {
                    ...dados,
                    ...{ acao: acao },
                    ...{ empresa: empresa },
                    ...{ parcelaabater: parcelaabater }
                }
            })
                .then(function (response) {
                    toast.success("Dados salvos com sucesso!");
                    history.push({
                        pathname: "/financeiroParcelaReceber",
                        state: { idTitulo: id }
                    });
                })
                .catch(function (error) {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        }
    };

    useEffect(() => { //onload
        setFullTrail([
            { path: '/financeiro', label: 'Financeiro' },
            { path: '/financeiroParcelaReceber', label: 'Contas a Receber' },
            { path: '/cadastroParcelaReceber' + (id ? '/' + id : ''), label: id ? 'Editar título' : 'Nova receita' },
        ]);
        buscar();
    },
        // eslint-disable-next-line
        []);

    // Loaders dos selects (mesmos endpoints/formatos de sempre)
    const loadClientes = (input) => api({
        method: 'get', action: '/participante', token: token,
        params: { nome: input, situacaoRegistro: "ativo" },
    }).then(response => response.data.data.map((registro) => ({
        value: registro.id,
        label: registro.codigo +
            ' - ' + registro.nome +
            (registro.enderecomunicipio ? ' - ' + registro.enderecomunicipio.nome + '-' + registro.enderecomunicipio.uf : '') +
            (registro.cnpj ? ' (' + registro.cnpj + ')' : '') +
            (registro.cpf ? ' (' + registro.cpf + ')' : '') +
            (registro.nomefantasia ? ' - ' + registro.nomefantasia : ''),
    }))).catch(function (error) { });

    const loadPlanoContas = (input) => api({
        method: 'get', action: '/financeiroPlanoConta', token: token,
        params: { nome: input, tipo: "1", situacaoRegistro: "ativo" },
    }).then(response => response.data.data.map(registro => ({ value: registro.id, label: registro.caminho + ' - ' + registro.nome })))
        .catch(function (error) { });

    const loadEventos = (input) => api({
        method: 'get', action: '/evento', token: token,
        params: { nome: input, situacaoRegistro: "ativo" },
    }).then(response => response.data.data.map((registro) => ({
        value: registro.id,
        label: (registro.codigo ? registro.codigo + ' - ' : '') + (registro.nome || ''),
    }))).catch(function (error) { });

    const loadEspecies = (input) => api({
        method: 'get', action: '/financeiroEspecie', token: token, params: { nome: input },
    }).then(response => response.data.data.map(registro => ({ value: registro.id, label: registro.nome })))
        .catch(function (error) { });

    const loadCaixas = (input) => api({
        method: 'get', action: '/financeiroCaixa', token: token, params: { nome: input },
    }).then(response => response.data.data.map(registro => ({ value: registro.id, label: registro.nome })))
        .catch(function (error) { });

    const totalDaLinha = (rowIndex) =>
        ((dados.tituloparcela[rowIndex].valor || 0) +
            (dados.tituloparcela[rowIndex].juros || 0) -
            (dados.tituloparcela[rowIndex].desconto || 0));

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <form className="form" onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                    {/* ── Header ── */}
                    <div className="fin-pp__head">
                        <div>
                            <h1 className="fin-pp__title">{id ? 'Editar título a receber' : 'Nova receita'}</h1>
                            <p className="fin-pp__subtitle">
                                {dados.descricao || 'Título e parcelas de contas a receber'}
                            </p>
                        </div>
                        <div className="fin-pp__actions">
                            <button type="button" className="fin-pp__btn" onClick={() => history.goBack()}>
                                <FaArrowLeft size={14} /> Voltar
                            </button>
                            <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={isSubmitting}>
                                <FaSave size={14} /> {isSubmitting ? 'Salvando...' : 'Salvar'}
                            </button>
                        </div>
                    </div>

                    {/* ── Dados do título ── */}
                    <section className="fin-pp__region" style={{ marginBottom: 18 }}>
                        <div className="fin-pp__cphead">
                            <span className="fin-pp__cphead-ic"><FaFileInvoiceDollar size={17} /></span>
                            <div>
                                <h2 className="fin-pp__cphead-title">Dados do título</h2>
                                <p className="fin-pp__cphead-sub">Cliente, classificação e identificação da receita</p>
                            </div>
                        </div>
                        <div className="fin-pp__card" style={{ padding: 16 }}>
                            <div className="fin-pp__filters">
                                <FinField label="Cliente" grow>
                                    <ReactSelect
                                        value={{ value: dados.participante, label: dados.nomeParticipante }}
                                        onChange={e => setDados({ ...dados, ...{ "participante": e.value, "nomeParticipante": e.label } })}
                                        loadOptions={loadClientes}
                                    />
                                </FinField>
                                <FinField label="Número">
                                    <FinInput
                                        value={dados.numero || ''}
                                        onChange={e => setDados({ ...dados, ...{ "numero": e.target.value } })}
                                    />
                                </FinField>
                                <FinField label="Plano de Contas" required grow>
                                    <ReactSelect
                                        value={{ value: dados.conta, label: dados.nomeConta }}
                                        onChange={e => setDados({ ...dados, ...{ "conta": e.value, "nomeConta": e.label } })}
                                        loadOptions={loadPlanoContas}
                                    />
                                </FinField>
                                <Data
                                    label="Competência"
                                    labelExterno
                                    value={dados.competencia}
                                    onChange={date => setDados({ ...dados, ...{ "competencia": date } })}
                                />
                                <FinField label="Evento" grow>
                                    <ReactSelect
                                        value={{ value: dados.evento, label: dados.nomeEvento }}
                                        onChange={e => setDados({ ...dados, ...{ "evento": e.value, "nomeEvento": e.label } })}
                                        loadOptions={loadEventos}
                                    />
                                </FinField>
                                <FinField label="Descrição" full>
                                    <FinInput
                                        value={dados.descricao || ''}
                                        onChange={e => setDados({ ...dados, ...{ "descricao": e.target.value } })}
                                    />
                                </FinField>
                                <FinField label="Observações" full>
                                    <FinTextarea
                                        rows={3}
                                        value={dados.observacao || ''}
                                        onChange={e => setDados({ ...dados, ...{ "observacao": e.target.value } })}
                                    />
                                </FinField>
                            </div>
                        </div>
                    </section>

                    {/* ── Parcelas ── */}
                    <section className="fin-pp__region" style={{ marginBottom: 18 }}>
                        <div className="fin-pp__cphead">
                            <span className="fin-pp__cphead-ic"><FaMoneyCheckAlt size={17} /></span>
                            <div>
                                <h2 className="fin-pp__cphead-title">Parcelas</h2>
                                <p className="fin-pp__cphead-sub">Espécie, caixa de destino, valores e vencimento de cada parcela</p>
                            </div>
                            <span className="fin-pp__cphead-pill is-warn" style={{ background: 'var(--fin-acw)', color: 'var(--fin-ac)' }}>
                                {(dados.tituloparcela || []).length} parcela{(dados.tituloparcela || []).length !== 1 ? 's' : ''}
                            </span>
                        </div>
                        <div className="fin-pp__card" style={{ overflow: 'visible' }}>
                            <div className="fin-pp__tblwrap" style={{ overflow: 'visible' }}>
                                <table className="fin-pp__tbl" style={{ minWidth: 1080, tableLayout: 'auto' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: 220 }}>Espécie</th>
                                            <th style={{ width: 220 }}>Caixa</th>
                                            <th style={{ width: 130 }}>Valor</th>
                                            <th style={{ width: 120 }}>Desconto</th>
                                            <th style={{ width: 120 }}>Juros</th>
                                            <th style={{ width: 150 }}>Vencimento</th>
                                            <th className="text-end" style={{ width: 120 }}>Total</th>
                                            <th style={{ width: 54 }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(dados.tituloparcela || []).length === 0 && (
                                            <tr><td colSpan={8} className="fin-pp__empty">Nenhuma parcela — adicione a primeira abaixo.</td></tr>
                                        )}
                                        {dados.tituloparcela ? dados.tituloparcela.map((row, rowIndex) => (
                                            <tr key={rowIndex}>
                                                <td>
                                                    <ReactSelect
                                                        compact
                                                        value={{ value: row.especie.id, label: row.especie.nome }}
                                                        onChange={(e) => {
                                                            dados.tituloparcela[rowIndex].especie.id = e.value;
                                                            dados.tituloparcela[rowIndex].especie.nome = e.label;
                                                            setDados({ ...dados });
                                                        }}
                                                        defaultOptions
                                                        loadOptions={loadEspecies}
                                                    />
                                                </td>
                                                <td>
                                                    <ReactSelect
                                                        compact
                                                        value={{ value: row.caixa?.id, label: row.caixa?.nome }}
                                                        onChange={(e) => {
                                                            dados.tituloparcela[rowIndex].caixa = {};
                                                            dados.tituloparcela[rowIndex].caixa.id = e.value;
                                                            dados.tituloparcela[rowIndex].caixa.nome = e.label;
                                                            setDados({ ...dados });
                                                        }}
                                                        defaultOptions
                                                        loadOptions={loadCaixas}
                                                    />
                                                </td>
                                                <td>
                                                    <FinValor allowNegative={false}
                                                        fixedDecimalScale
                                                        style={{ height: 38, textAlign: 'right' }}
                                                        value={dados.tituloparcela[rowIndex].valor}
                                                        onValueChange={(values) => {
                                                            dados.tituloparcela[rowIndex].valor = values.floatValue;
                                                            calculaTotalParcelaReceber();
                                                            setDados({ ...dados });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <FinValor allowNegative={false}
                                                        fixedDecimalScale
                                                        style={{ height: 38, textAlign: 'right' }}
                                                        value={dados.tituloparcela[rowIndex].desconto || 0}
                                                        onValueChange={(values) => {
                                                            dados.tituloparcela[rowIndex].desconto = values.floatValue || 0;
                                                            calculaTotalParcelaReceber();
                                                            setDados({ ...dados });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <FinValor allowNegative={false}
                                                        fixedDecimalScale
                                                        style={{ height: 38, textAlign: 'right' }}
                                                        value={dados.tituloparcela[rowIndex].juros || 0}
                                                        onValueChange={(values) => {
                                                            dados.tituloparcela[rowIndex].juros = values.floatValue || 0;
                                                            calculaTotalParcelaReceber();
                                                            setDados({ ...dados });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <Data
                                                        label="Vencimento"
                                                        value={row.vencimento}
                                                        onChange={(date) => {
                                                            dados.tituloparcela[rowIndex].vencimento = date;
                                                            setDados({ ...dados });
                                                        }}
                                                    />
                                                </td>
                                                <td className="fin-pp__cell-num">
                                                    {pontoVirgula(totalDaLinha(rowIndex))}
                                                </td>
                                                <td>
                                                    <button type="button" className="fin-pp__btn fin-pp__btn--danger-ghost fin-pp__btn--sm"
                                                        title="Remover parcela" aria-label="Remover parcela"
                                                        onClick={() => {
                                                            dados.tituloparcela.splice(rowIndex, 1);
                                                            calculaTotalParcelaReceber();
                                                            setDados({ ...dados });
                                                        }}>
                                                        <FaTrash size={13} />
                                                    </button>
                                                </td>
                                            </tr>
                                        )) : null}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan={6} style={{ textAlign: 'right', fontWeight: 600, color: 'var(--fin-mt)' }}>Total geral</td>
                                            <td className="fin-pp__cell-num" style={{ fontSize: '0.95rem' }}>{pontoVirgula(dados.valorTotal || 0)}</td>
                                            <td></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            <div style={{ padding: '10px 14px', borderTop: '1px solid var(--fin-bd)' }}>
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm w-100"
                                    style={{ border: '1px dashed #ced4da', color: '#6c757d' }}
                                    onClick={() => {
                                        //tipo: 1 - pagar | 2 - receber
                                        dados.tituloparcela.push({
                                            empresa: empresa,
                                            tipo: 2,
                                            vencimento: null,
                                            valor: 0,
                                            desconto: 0,
                                            juros: 0,
                                            total: 0,
                                            especie: {
                                                id: null,
                                                nome: null
                                            },
                                            caixa: {
                                                id: null,
                                                nome: null
                                            }
                                        });
                                        setDados({ ...dados });
                                    }}>
                                    <FaPlus size={13} /> Adicionar Parcela
                                </button>
                            </div>
                        </div>
                    </section>

                    {/* ── Rodapé de ação ── */}
                    <div className="d-flex justify-content-end" style={{ marginBottom: 24 }}>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--tall" disabled={isSubmitting}>
                            <FaSave size={15} /> {isSubmitting ? 'Salvando...' : 'Salvar título'}
                        </button>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
